import React, { useEffect, useState } from 'react';
import { UploadCloud, Info,CheckCircle,ChevronRight, FileText, Loader2, ArrowRight, Lock, XCircle, Eye, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UploadBerkas = ({ onSwitchTab }) => {
  const [documents, setDocuments] = useState([]);
  const [uploadingIds, setUploadingIds] = useState({});
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [isProfileComplete, setIsProfileComplete] = useState(null); 
  const [pakStatus, setPakStatus] = useState({ isLocked: false, status: '' });
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [isComplete, setIsComplete] = useState(false);
  const [showCompletePopup, setShowCompletePopup] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false); // Agar popup tidak muncul terus-terusan
  // STATE UNTUK MODAL PREVIEW DOKUMEN
  const [previewUrl, setPreviewUrl] = useState(null);

  const navigate = useNavigate();

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => { setToast({ show: false, message: '', type: 'success' }); }, 3000);
  };

  useEffect(() => { checkEligibility(); }, []);

  const checkEligibility = async () => {
    const token = localStorage.getItem('token');
    try {
        const [statusRes, pakStatusRes] = await Promise.all([
           fetch(`${BASE_URL}/api/check-profile-status`, { headers: { 'Authorization': `Bearer ${token}` } }),
           fetch(`${BASE_URL}/api/pak/status`, { headers: { 'Authorization': `Bearer ${token}` } })
        ]);

        const statusData = await statusRes.json();
        
        if (pakStatusRes.ok) {
            const pakData = await pakStatusRes.json();
            if (pakData.submitted && pakData.status !== 'Ditolak') {
                setPakStatus({ isLocked: true, status: pakData.status });
            }
        }

        setIsProfileComplete(statusData.isComplete);
        if (statusData.isComplete) fetchDocuments(token);
    } catch (err) {
        showToast("Gagal memuat status, periksa koneksi internet", "error");
    }
  };

  const fetchDocuments = async (token) => {
    try {
        const res = await fetch(`${BASE_URL}/api/my-documents`, { headers: { 'Authorization': `Bearer ${token}` }});
        const data = await res.json();
        const sortedData = data.sort((a, b) => Number(b.is_mandatory) - Number(a.is_mandatory));
        setDocuments(sortedData);
      const cekKelengkapan = data.every(doc => !doc.is_mandatory || doc.view_link);
      setIsComplete(cekKelengkapan);

      if (cekKelengkapan && !hasShownPopup) {
          setShowCompletePopup(true);
          setHasShownPopup(true);
      }
    } catch (err) { console.error(err); }
  };

  const handleFileUpload = async (e, typeId, typeName) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 900 * 1024) return showToast("File terlalu besar! Maksimal 900 KB.", "error");

    const formData = new FormData();
    formData.append('file', file);
    formData.append('doc_type_id', typeId);
    formData.append('doc_name', typeName);
    
    setUploadingIds(prev => ({ ...prev, [typeId]: true }));
    const token = localStorage.getItem('token');

    try {
      const res = await fetch(`${BASE_URL}/api/upload`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: formData
      });
      if (res.ok) { showToast("Berkas berhasil diupload!", "success"); await fetchDocuments(token); } 
      else { const result = await res.json(); showToast("Gagal: " + result.msg, "error"); }
    } catch (err) { showToast("Terjadi kesalahan koneksi.", "error"); } 
    finally { setUploadingIds(prev => ({ ...prev, [typeId]: false })); e.target.value = null; }
  };

  if (isProfileComplete === null) return <div className="p-10 text-center flex justify-center"><Loader2 className="animate-spin"/></div>;

  if (isProfileComplete === false) {
    return (
        <div className="max-w-4xl mx-auto p-6 md:p-12 mt-6">
            <div className="bg-red-50 border border-red-200 rounded-2xl p-8 text-center">
                <Lock size={40} className="text-red-600 mx-auto mb-4" />
                <h2 className="text-3xl font-serif mb-3">Upload Terkunci</h2>
                <p className="mb-6">Lengkapi Biodata Profil Anda terlebih dahulu.</p>
                <button onClick={() => onSwitchTab('profil')} className="bg-red-600 text-white px-8 py-3 rounded-xl font-bold inline-flex items-center gap-2">
                    Lengkapi Profil <ArrowRight size={20}/>
                </button>
            </div>
        </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-4 md:p-8 relative">
     

      {/* FLOATING BUTTON (Hanya muncul jika isComplete === true) */}
      {isComplete && (
        <div className="fixed bottom-6 right-6 md:bottom-10 md:right-10 z-50 animate-bounce">
           <button onClick={() => onSwitchTab('inputpak')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-4 rounded-full shadow-2xl font-bold flex items-center gap-3 text-lg border-4 border-white">
             Lanjut Input PAK <ChevronRight size={24} />
           </button>
        </div>
      )}
      {toast.show && (
        <div className={`fixed top-6 right-6 z-[60] flex items-center gap-3 px-6 py-4 rounded-xl shadow-2xl text-white ${toast.type === 'success' ? 'bg-emerald-600' : 'bg-rose-600'}`}>
          {toast.type === 'success' ? <CheckCircle size={24} /> : <XCircle size={24} />}
          <p className="font-semibold">{toast.message}</p>
        </div>
      )}

      {/* === MODAL PREVIEW DOKUMEN === */}
      {previewUrl && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm px-4 md:px-10 py-6">
          <div className="bg-white w-full max-w-5xl h-full flex flex-col rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up">
            <div className="flex justify-between items-center p-4 border-b bg-slate-50">
              <h3 className="font-bold text-slate-800 flex items-center gap-2">
                <FileText size={18} className="text-blue-600"/> Preview Dokumen
              </h3>
              <button onClick={() => setPreviewUrl(null)} className="p-2 hover:bg-rose-100 text-slate-500 hover:text-rose-600 rounded-full transition-colors">
                <X size={20} />
              </button>
            </div>
            <div className="flex-1 w-full bg-slate-200">
              <iframe 
                src={previewUrl.includes('drive.google.com') ? previewUrl.replace(/\/view.*/, '/preview') : previewUrl} 
                className="w-full h-full border-none" 
                title="Preview"
              ></iframe>
            </div>
          </div>
        </div>
      )}
      
      <div className="mb-8 border-b pb-6">
        <h1 className="text-3xl font-serif mb-2">Upload Berkas Persyaratan</h1>
        <p className="text-slate-500">Pastikan format PDF/JPG maksimal 900KB.</p>
      </div>
<div className="mb-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg shadow-sm flex items-start gap-3">
  <Info className="text-blue-600 shrink-0 mt-0.5" size={22} />
  <div>
    <h3 className="font-bold text-blue-900 text-sm">Petunjuk Unggah Berkas</h3>
    <p className="text-sm text-blue-800 mt-1 leading-relaxed">
      Bapak/Ibu diwajibkan untuk mengunggah <b>seluruh berkas persyaratan yang berstatus "Wajib"</b>. Usulan PAK tidak akan bisa dilanjutkan ke tahap Input PAK dan Pengiriman jika masih ada dokumen wajib yang belum terunggah.
    </p>
  </div>
</div>
      {/* TAMPILAN JIKA TERKUNCI (TETAP MUNCUL DI ATAS DOKUMEN) */}
      {pakStatus.isLocked && (
        <div className={`mb-6 p-6 rounded-xl border flex items-start gap-4 ${pakStatus.status === 'Disetujui' ? 'bg-blue-50 border-blue-200' : 'bg-slate-50 border-slate-200'}`}>
           <Lock size={28} className={pakStatus.status === 'Disetujui' ? 'text-blue-600' : 'text-slate-600'} />
           <div>
             <h3 className="font-bold text-lg">{pakStatus.status === 'Disetujui' ? 'Berkas Disetujui' : 'Upload Terkunci'}</h3>
             <p className="text-sm text-slate-600">
               {pakStatus.status === 'Disetujui' 
                 ? 'Berkas Anda telah disetujui. Anda tetap bisa melihat dokumen di bawah ini.' 
                 : 'Pengajuan sedang diproses. Anda tidak diizinkan mengubah berkas, namun tetap bisa melihatnya.'}
             </p>
           </div>
        </div>
      )}

      <div className="grid gap-4">
        {documents.map((doc) => {
          const isUploading = uploadingIds[doc.type_id];
          return (
          <div key={doc.type_id} className={`p-6 rounded-xl border ${doc.upload_id ? 'bg-white border-green-200' : 'bg-white border-slate-200'}`}>
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex items-start gap-4">
                    <div className={`p-3 rounded-full mt-1 ${doc.upload_id ? 'bg-green-100 text-green-600' : 'bg-slate-100 text-slate-400'}`}>
                        {doc.upload_id ? <CheckCircle size={24} /> : <FileText size={24} />}
                    </div>
                    <div>
                        <div className="flex items-center gap-3 mb-1">
                            <h3 className="font-bold text-lg">{doc.name}</h3>
                            {doc.is_mandatory && <span className="bg-red-50 text-red-600 text-[10px] font-bold px-2 py-1 rounded border border-red-100">WAJIB</span>}
                        </div>
                        <p className="text-sm text-slate-500">{doc.upload_id ? <span className="text-green-600 font-medium">Sudah diunggah</span> : <span>Belum ada berkas</span>}</p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    {doc.upload_id && (
                        <button type="button" onClick={() => setPreviewUrl(doc.view_link)} className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200">
                            <Eye size={16} /> Lihat
                        </button>
                    )}
                    
                    {/* SEMBUNYIKAN TOMBOL UPLOAD JIKA STATUS TERKUNCI */}
                    {!pakStatus.isLocked && (
                      <div className="relative">
                          <input type="file" id={`file-${doc.type_id}`} className="hidden" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => handleFileUpload(e, doc.type_id, doc.name)} disabled={isUploading} />
                          <label htmlFor={`file-${doc.type_id}`} className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold cursor-pointer ${isUploading ? 'bg-slate-100 text-slate-400' : doc.upload_id ? 'bg-white border text-slate-700' : 'bg-slate-900 text-white'}`}>
                              {isUploading ? <><Loader2 className="animate-spin" size={16}/> Proses</> : <><UploadCloud size={16}/> {doc.upload_id ? "Ganti" : "Upload"}</>}
                          </label>
                      </div>
                    )}
                </div>
            </div>
          </div>
        )})}
      </div>
      {/* BUTTON LANJUT DINAMIS (Tanpa Popup) */}
      <div className="fixed bottom-6 right-6 md:bottom-10 md:right-10 z-50">
        <button 
          onClick={() => isComplete && onSwitchTab('inputpak')} 
          disabled={!isComplete}
          className={`px-6 py-4 rounded-full shadow-2xl font-bold flex items-center gap-3 text-lg border-4 border-white transition-all duration-300 ${
            isComplete 
              ? 'bg-emerald-600 hover:bg-emerald-700 text-white animate-bounce cursor-pointer' 
              : 'bg-slate-300 text-slate-500 cursor-not-allowed opacity-80'
          }`}
        >
          {isComplete ? 'Lanjut Input PAK' : 'Lengkapi Berkas Dulu'} <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default UploadBerkas;